import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import TestimonialSlider from "../Common/testamonialSlider";

import Slider from "react-slick";
import CustomNextArrow from "../Common/customNextArrow";
import CustomPrevArrow from "../Common/customPrevArrow";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import women1 from "../../assets/images/women1.png";

export default function Testimonials() {
  const testimonials = [
    {
      name: "Customer1",
      value: 2,
      image: women1,
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      name: "Customer 2",
      value: 5,
      image: women1,
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      name: "Customer3",
      value: 1,
      image: women1,
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
    {
      name: "Customer 4",
      value: 4,
      image: women1,
      description:
        "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.",
    },
  ];

  const settings = {
    infinite: true,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
        },
      },
    ],
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "blue.main",
          paddingLeft: { lg: "113px", xs: "0px" },
          paddingX: { lg: "30px", xs: "0px" },
        }}
      >
        <Typography
        variant="h4"
          sx={{
            fontStyle: "normal",
            fontWeight: 'bold',
            textAlign: "center",
            textTransform: "uppercase",
            color: "white.main",
            paddingTop: "70px",
          }}
        >
          What our loyal customers say about us?{" "}
        </Typography>
        <Box display={"flex"} justifyContent={"center"}>
          <Typography
            sx={{
              textAlign: "center",
              width: "60%",
              lineHeight: "30px",
              marginBottom: "0px",
              paddingBottom: "0px",
              marginY: "15px",
              color: "white.light",
            }}
          >
            Lorem ipsum dolor sit amet consectetur. At elementum pellentesque
            leo pellentesque donec pulvinar. Nascetur mauris egestas duis mollis
            ornare. Sed luctus donec sit mauris justo. Massa quam.{" "}
          </Typography>
        </Box>
        
        <Grid
          container
          justifyContent={"center"}
          sx={{ paddingBottom: "52px" }}
        >
          <Grid item xs={8} className={"testimonials"}>
            <Box>
              <Box className={` slider `}>
                <Slider {...settings}>
                  {testimonials.map((data) => (
                    <TestimonialSlider
                      name={data.name}
                      value={data.value}
                      image={data.image}
                      description={data.description}
                    />
                  ))}
                </Slider>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
